import React, { useEffect, useState, useMemo } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
// import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import axios from "axios";
import DataTable from "react-data-table-component";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import DeleteConfirmationModal from "../../../components/Modal/DeleteConfirmation";
import { DATA_EXPORT, ERROR_MESSAGE } from "../../../common/Constant";
import { toastError, toastSuccess } from "../../../common/Toast";
import CleanupConfirmationModal from "../../../components/Modal/CleanupConfirmation";
import { checkUserPermission } from "../../../common/UserPermission";
import * as XLSX from "xlsx";

//MUI Table
import { MaterialReactTable } from "material-react-table";
import { MenuItem } from "@mui/material";
import { Box, Button } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

// The below variable are for permission given to the Functionalities
let PERMISSION_ADD = "/new-email-templates";
let PERMISSION_EDIT = "/new-email-templates/:id";
let PERMISSION_DELETE = "delete-appointment";

const EmailTemplates = () => {
  const paramObject = useParams();
  let selectData = [];
  let pathforpdf = "";
  let selectDatas = [];
  const token = localStorage.getItem("Token");
  const [perPageSize, setperPageSize] = useState(10);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [data, setData] = useState([]);
  const [sortingId, setSortingId] = useState(6);
  const [state, setState] = useState("");
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [selectedAppointmentsCheckboxs, setselectedAppointmentCheckbox] =
    useState("");
  const [selectedItemskitCheckEmails, setselectedItemskitCheckEmails] =
    useState("");
  const [selectedItemskitCheckpathforpdf, setselectedItemskitCheckpathforpdf] =
    useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [hiddenColumns, setHiddenColumns] = useState([]);

  //----------------Server-Side------------------//
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const navigate = useNavigate();

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const onBtExport = (filterData, field) => {
    const workbook = XLSX.utils.book_new();

    let Data = [];

    if (field === "AllData") {
      Data = data;
    } else {
      Data = filterData?.map((el) => el?.original);
    }

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(Data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Exel_File.xlsx`);
  };

  // Get all tag data
  const handleListData = (
    pagenumber,
    pagesize,
    filtertext,
    ordercolumn,
    currentorder,
    columnFilters,
    globalFilter,
    pagination,
    sorting
  ) => {
    // setLoading(true);
    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    // const columnIndex = columns.findIndex(
    //   (column) => column.accessorKey === sorting[0]?.id
    // );
    const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
    axios
      .get(
        `${
          config.generalBaseUrl
        }/generals?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&ordercolumn=${columnIndex}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setData(res.data.ResponseData);
        console.log("data", data);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  const handleRowSelected = (e) => {
    if (e.selectedRows.length > 0) {
      // for get detlais form id
      setSelectedRows(e.selectedRows.map((x) => x.ID));
      selectData[currentPage] = e.selectedRows.map((x) => x.ID);
      const selectedItemsCheckboxIDs =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedAppointmentCheckbox(selectedItemsCheckboxIDs);

      const datasplitforpath = selectedItemsCheckboxIDs?.split(",");
      pathforpdf = datasplitforpath?.join("~");
      setselectedItemskitCheckpathforpdf(pathforpdf);

      // get emails of selectdids
      setSelectedRows(e.selectedRows.map((x) => x.Email));
      selectData[currentPage] = e.selectedRows.map((x) => x.Email);
      const selectedItemsCheckboxEmails =
        selectData.length > 0 ? selectData[currentPage].toString() : "";
      setselectedItemskitCheckEmails(selectedItemsCheckboxEmails);
    }
  };

  const handleDeletePopup = (pID) => {
    console.log("pID", pID);
    console.log("selectedItemskitCheckboxs", selectedAppointmentsCheckboxs);
    const deleteRequestParam = {
      // write postman ID here!

      appointmentIDs: pID || selectedAppointmentsCheckboxs,
    };
    localStorage.setItem(
      "DeleteRequestParam",
      JSON.stringify(deleteRequestParam)
    );
  };

  const contextActions = useMemo(() => {
    return (
      <>
        <div className="row px-2">
          <div className="col-12 align-self-center">
            {/* {checkUserPermission(PERMISSION_DELETE) ? (
              <button
                type="button"
                className="btn btn-danger btn-sm pull-left "
                data-bs-toggle="modal"
                data-bs-target="#DeleteConfirmationModal"
                onClick={() => handleDeletePopup()}
              >
                <i className="fa fa-trash fa-sm" /> Delete Selected
              </button>
            ) : (
              ""
            )} */}
          </div>
        </div>
      </>
    );
  }, [data, selectedRows, toggleCleared]);

  const formatDate = (string) => {
    var options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(string).toLocaleDateString([], options);
  };

  useEffect(() => {
    console.log();
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      columnFilters,
      globalFilter,
      pagination,
      sorting
    );
  }, [columnFilters, globalFilter, pagination, sorting]);

  // Table Data
  // const columns = [
  //   {
  //     name: "ID",
  //     selector: "ID",
  //     width: "20%",
  //     sortable: true,
  //   },
  //   {
  //     name: "EmailTemplates",
  //     selector: "EmailTemplates",
  //     sortable: true,
  //     width: "20%",
  //   },
  //   {
  //     name: "EmailSubject",
  //     selector: "EmailSubject",
  //     sortable: true,
  //     width: "20%",
  //   },
  //   {
  //     name: "IsActive ",
  //     selector: "IsActive.data",
  //     sortable: true,
  //     width: "20%",
  //   },
  //   {
  //     name: "Action",
  //     cell: (row) => (
  //       <>
  //         {checkUserPermission(PERMISSION_EDIT) ? (
  //           <Link className="me-3" to={`/new-email-templates/${row.ID}`}>
  //             <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //           </Link>
  //         ) : (
  //           ""
  //         )}
  //         {/* {checkUserPermission(PERMISSION_DELETE) ? (
  //           <Link
  //             className="confirm-text"
  //             to="#"
  //             title="Delete"
  //             data-bs-toggle="modal"
  //             data-bs-target="#DeleteConfirmationModal"
  //             onClick={() => handleDeletePopup(row.ID)}
  //           >
  //             <i
  //               className="fa fa-trash text-red fa-2x"
  //               data-bs-toggle="tooltip"
  //               title="Delete"
  //             ></i>
  //           </Link>
  //         ) : (
  //           ""
  //         )} */}
  //       </>
  //     ),
  //     ignoreRowClick: true,
  //     allowOverflow: true,
  //     button: true,
  //   },
  // ];

  const columns = useMemo(() => [
    {
      header: "ID",
      accessorKey: "ID",
      // size: 120,
      Cell: checkUserPermission(PERMISSION_EDIT) 
        ? ({ row }) => (
            <Box
              component="span"
              sx={(theme) => ({
                borderRadius: "0.3rem",
                color: "#343f62",
                maxWidth: "18ch",
                fontWeight:"700",
                textDecoration:"underline",
                textUnderlineOffset: "3px",
                p: "0.3rem",
                cursor: "pointer",
              })}
              onClick={() =>
                navigate(`/new-email-templates/${row.original.ID}`)
              }
            >
              {row.original.ID}
            </Box>
          ) 
        : null,
      filterFn: "contains",
    },
    {
      header: "EmailTemplates",
      accessorKey: "EmailTemplates",
      // size: "300",
    },
    {
      header: "EmailSubject",
      accessorKey: "EmailSubject",
      // size: "300",
    },
    {
      header: "EmailCC",
      accessorKey: "EmailCC",
      // size: "300",
    },
    // {
    //   header: "IsActive",
    //   accessorKey: "IsActive",
    //   size:"50",
    // },
  ]);

  // const handleSelectedRowsChange = (e) => {
  //     if (e.selectedRows.length > 0) {
  //         setSelectedData(e.selectedRows.map(x => x.ID));
  //         selectData[currentPage] = e.selectedRows.map(x => x.ID);
  //     }
  // }

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(1, perPageSize, searchtext, e.id, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  // store checkbox checked values to hide or show columns

  function handleCheckboxChange(columnName) {
    if (hiddenColumns.includes(columnName)) {
      setHiddenColumns(hiddenColumns.filter((column) => column !== columnName));
    } else {
      setHiddenColumns([...hiddenColumns, columnName]);
    }
  }

  // generate new columns according to hiddenColumns data and pass it as datatable column
  // const filteredColumns = columns.filter(
  //   (column) => !hiddenColumns.includes(column.name.replace(/\s+|-|\/|#/g, ""))
  // );

  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <div className="col"> */}
              {/* <h3 className="page-title">Email Templates</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "11px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item active">Email Templates List</li>
              </ul>
              {/* </div> */}
            </div>
          </div>
          <div>
            <div className="btn-group  pull-right ms-2">
              <button type="button" className="btn btn-action d-none">
                Action
              </button>
            </div>

            {checkUserPermission(PERMISSION_ADD) ? (
              <Link
                to="/new-email-templates"
                className="btn btn-primary btn-sm pull-right"
                style={{ width: "max-content" }}
              >
                <i className="fa fa-plus me-2 lg"></i>
                New Email Templates
              </Link>
            ) : (
              ""
            )}
            {checkUserPermission("export-button") ? (
              <button
                // className="btn btn-added pull-right"
                className="btn btn-sm btn-outline-dark btn-sm pull-right mr-3"
                style={{ width: "max-content" }}
                onClick={() => onBtExport([], "AllData")}
              >
                <i
                  className="fa fa-download mr-2"
                  style={{ color: "#111930" }}
                ></i>
                Export Visible Column
                {/* <i class="fa-thin fa-download"></i> */}
              </button>
            ) : (
              ""
            )}
          </div>
          <br />
          <br />
          <div className="row flex-row-reverse ">
            <div className="col-2 float-end">
              {/* <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control"
                onChange={ChangeFilterText}
                value={searchtext}
              /> */}
            </div>
          </div>

          {/* Items list */}
          {/* <div className="card">
            <div className="card-body">
              <div className="table-responsive">
                <DataTable
                  title="Email Templates List"
                  columns={filteredColumns}
                  data={data}
                  progressPending={loading}
                  pagination
                  paginationServer
                  paginationTotalRows={totalRows}
                  paginationDefaultPage={currentPage}
                  onChangeRowsPerPage={(e) => {
                    handlePerRowsChange(1, e);
                  }}
                  onChangePage={handlePageChange}
                  highlightOnHover
                  striped
                  responsive
                  paginationRowsPerPageOptions={[10, 25, 50, 100, 500]}
                  persistTableHead
                  sortServer
                  onSort={handleSort}
                  contextActions={contextActions}
                  onSelectedRowsChange={handleRowSelected}
                  clearSelectedRows={toggleCleared}
                />
              </div>
            </div>
          </div> */}
          <MaterialReactTable
            columns={columns}
            data={data}
              columnSizing = {{
      "mrt-row-select": 50,
      "mrt-row-actions": 50,
    }}
    layoutMode = "grid-no-grow" // 'semantic' | 'grid' | 'grid-no-grow'
            enableColumnResizing
            enableRowActions={checkUserPermission(PERMISSION_EDIT)}
            positionGlobalFilter="left"
            renderRowActionMenuItems={({ row }) => [
              checkUserPermission(PERMISSION_EDIT) ? (
                <MenuItem
                  key="edit"
                  onClick={() =>
                    navigate(`/new-email-templates/${row.original.ID}`)
                  }
                >
                  Edit
                </MenuItem>
              ) : (
                ""
              ),
            ]}
            enableGrouping
            enableStickyHeader
            enableStickyFooter
            enableRowSelection
            enableColumnOrdering
            initialState={{
              density: "compact",
              showGlobalFilter: true,
              expanded: true, //expand all groups by default
              // grouping: [""], //an array of columns to group by by default (can be multiple)
              pagination: { pageIndex: 0, pageSize: 25 },
              sorting: [{ id: "state", desc: false }], //sort by state by default
            }}
            // muiToolbarAlertBannerChipProps={{ color: "primary" }}
            // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
            muiTableBodyProps={{
              sx: () => ({
                "& tr:nth-of-type(even)": {
                  backgroundColor: "var(--datatable-row-background-color)",
                  //'rgb(237 237 233 / 63%)'
                },
                "& td": {
                  borderRight:
                    "1px solid var(--datatable-row-background-hover-color)",
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },

                "& tr": {
                  lineHeight: "16px",
                  fontWeight: "400",
                  fontSize: "12px",
                  color: "var(--primary-color-800)",
                  fontFamily: "Inter",
                },
              }),
            }}
            muiPaginationProps={{
              rowsPerPageOptions: [10, 25, 50, 100, 300, 500],
            }}
            muiTableContainerProps={{ sx: { maxHeight: "fit-content" } }}
            // manualFiltering
            manualPagination
            manualSorting
            muiToolbarAlertBannerProps={
              isError
                ? {
                    color: "error",
                    children: "Error loading data",
                  }
                : undefined
            }
            // onColumnFiltersChange={setColumnFilters}
            muiTableHeadCellProps={{
              sx: (theme) => ({
                background: "var(--datatable-row-background-color)", //'#e9e9e9',
                borderRight:
                  "1px solid var(--datatable-row-background-hover-color)",
                lineHeight: "16px",
                fontWeight: "500",
                fontSize: "14px",
                color: "var(--primary-color-800)",
                fontFamily: "Inter",
              }),
            }}
            onGlobalFilterChange={setGlobalFilter}
            onPaginationChange={setPagination}
            onSortingChange={setSorting}
            rowCount={totalRows}
            state={{
              // columnFilters,
              globalFilter,
              isLoading,
              pagination,
              showAlertBanner: isError,
              showProgressBars: isRefetching,
              sorting,
            }}
          />
        </div>
      </div>

      {/* Delete Model  */}
      {/* <DeleteConfirmationModal
        deleteApiUrl={`${config.appointmentBaseUrl}/appointments/batchdelete`}
      /> */}

      {/* Cleanup old items */}
      {/* <CleanupConfirmationModal
        CleanupConformationApiUrl={`${config.itemKitsBaseUrl}/items/deletepermanantely`}
      /> */}
    </>
  );
};

export default EmailTemplates;
